import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
//import { history } from 'src/core/router'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
//import lang from './lang'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang:langM.en,
    language:'en',
    uesrInfo: {
      nickname: '',
      uid: '',
      avatarurl: '',
      gender: 3
    },
    hostSystemId: null,
    receiver: null,
    hostSystemName: ''
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    

    // end


    let uid = await setUidToken(this.props.location.query)
    if (language == 'tr') {
      setDocumentTitle('Yayıncılık Daveti')
    }else{
      setDocumentTitle('Host invitation')
    }
    
    let str = window.location.href
    let arr = str.split('?')[1].split('&')
    let sender = arr[0].split('=')[1] * 1
    let receiver = arr[1].split('=')[1] * 1
    let hostSystemId = arr[2].split('=')[1] * 1
    let hostSystemName = encodeURI(arr[4].split('=')[1])
    this.setState({
      hostSystemId,
      receiver,
      hostSystemName,
      sender,
      uid,
      status: 1
    })
    this.getStatus()
    this.findUser(sender)
  }
  agree = async () => {
    let { hostSystemId,  sender } = this.state
    let res = await http.post('/web/hostsystem/invite/confirm', { hostSystemId, uid: sender, status: 4 })
    if (res.code == 0) {
      this.getStatus()
      this.refs.msg.show(this.state.lang.successful)
    } else {
      this.refs.msg.show(this.state.lang.have)
    }
  }
  reject = async () => {
    let { hostSystemId,  sender } = this.state
    let res = await http.post('/web/hostsystem/invite/confirm', { hostSystemId, uid: sender, status: 2 })
    if (res.code == 0) {
      this.getStatus()
      this.refs.msg.show(this.state.lang.successful)
    } else {
      this.refs.msg.show(this.state.lang.have)
    }
  }
  getStatus = async () => {
    let { hostSystemId,  sender } = this.state
    let res = await http.post('/web/hostsystem/invite/status', { hostSystemId, uid: sender })
    if (res.code == 0) {
      this.setState({ status: res.res.status, hostSystemName: res.res.hostSystemName })
    }
  }
  findUser = async (a) => {
    let res = await http.post('/web/user/info', { uidDuid: a + '' })

    if (res.code == 0 && res.res) {
      this.setState({ uesrInfo: res.res })
    }
  }
  render() {
    let { lang, uesrInfo, hostSystemName, status, language,sender } = this.state
    return (
      <div className={`host-invitation ${language == 'ar'?'in-tr':''}` }>
        <div className="contnet">
          <div className="user-bg">
            <div className="avatar-root">
              <img className="avatar-img" src={uesrInfo.avatarurl}></img>
              {uesrInfo.gender == 1 && <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>}
              {uesrInfo.gender == 2 && <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>}
            </div>
            <div className="user-infos">
              <div className="user-info-top">
                <div className="top-text">{uesrInfo.nickname}</div>
              </div>
              <div className="user-info-buttom">ID:{uesrInfo.uid}</div>
            </div>
          </div>
          { language == 'en' &&<div className="contnet-text">
            {uesrInfo.nickname || ''} {lang.initGuild || ''}. {lang.doyou || ''} {hostSystemName || ''}
          </div>}
          { language == 'tr' &&<div className="contnet-text">
           {uesrInfo.nickname || ''} Sizi Ajansına davet ediyor. {hostSystemName || ''} yayıncısı olmayı kabul ediyor musunuz?
          </div>}
          { language == 'ar' && <div className="contnet-text">
             {lang.initGuild || ''} {uesrInfo.nickname || ''}. {hostSystemName || ''} {lang.doyou || ''} 
          </div>}
          {status == 1 && (
            <div className="agree" onClick={this.agree}>
              {lang.agree}
            </div>
          )}
          {status == 1 && (
            <div className="reject" onClick={this.reject}>
              {lang.reject}
            </div>
          )}
          {status == 3 && <div className="no-agree">{lang.agreed}</div>}
          {status == 2 && <div className="no-reject">{lang.rejected}</div>}
        </div>
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/host-invitation/index.js